// Warns that assigning an owner who doesn't manage the property grants them
// access to it. Uses the same MUI warning alert as the rest of the app.
import React from "react";
import { Alert, SxProps, Theme } from "@mui/material";

type AccessGrantWarningProps = {
  ownerName: string;
  propertyName: string;

  /** Spacing around the banner, which differs by where it sits. */
  sx?: SxProps<Theme>;
};

const AccessGrantWarning: React.FC<AccessGrantWarningProps> = ({ ownerName, propertyName, sx }) => (
  <Alert severity="warning" sx={sx}>
    This will give <strong>{ownerName}</strong> access to <strong>{propertyName}</strong>.
  </Alert>
);

export default AccessGrantWarning;
